type SpinnerProps = {
    size: 'extra-small' | 'small' | 'medium'
    className?: string
}
const Spinner = (props: SpinnerProps) => {
    const { size, className } = props

    return (
        <div>
            <div className={`flex justify-center items-center ${className ?? ''}`}>
                <div
                    className={`animate-spin rounded-full border-brand-primary border-t-2 border-b-2
                ${size === 'extra-small' && ' h-4 w-4 inline'}
                ${size === 'small' && 'h-5 w-5 inline'}
                ${size === 'medium' && 'h-7 w-7'}`}
                />
            </div>
        </div>
    )
}

export default Spinner
